import React from 'react';
import FindIcon from '@nokia-csf-uxr/ccfk-assets/FindIcon';
import { getContext } from 'common';

import Styled from './styles';

export interface TreeFilterIconProps extends React.ComponentPropsWithRef<'div'> {
  /** Icon for filter. Consider using `Icon` component. */
  children?: React.ReactNode;
}

/** TreeFilterIcon component. Any other props will be provided to the root element. */
const TreeFilterIcon = React.forwardRef<HTMLElement, TreeFilterIconProps>((props: TreeFilterIconProps, ref) =>
  getContext(({ RTL, theme }) => {
    const {
      children,
      ...otherProps
    } = props;
    return (
      <Styled.TreeFilterIcon ref={ref} $rtl={RTL} $theme={theme.TREE} {...otherProps}>
        {children}
      </Styled.TreeFilterIcon>
    );
  }));

TreeFilterIcon.displayName = 'TreeFilterIcon';
TreeFilterIcon.defaultProps = {
  children: <FindIcon aria-label="Search icon" />
};

export { TreeFilterIcon as default };
